import PlatformLoader from '@platform-ui/loader';
import type { LoaderProps } from '@platform-ui/loader';

export const Loader = (props: LoaderProps) => (
  <PlatformLoader size="m" centered overlay color="#3978CA" {...props} />
);
